import { AuthErrorCodes } from '@procom-labs/common'

export const FailedSocialLoginCallbackUrl = (message?: string): string => {
  const socialLoginContext = localStorage.getItem('socialLoginContext')

  let error: string | undefined

  if (message === AuthErrorCodes.InvalidEmailDomain) {
    error = 'invalidEmailDomain'
  }

  if (socialLoginContext) {
    localStorage.removeItem('socialLoginContext')
    const to =
      socialLoginContext.toLowerCase() === 'login'
        ? ''
        : socialLoginContext.toLowerCase()
    return `/${to}?${new URLSearchParams({
      error: error ?? `${socialLoginContext.toLowerCase()}Failed`,
    })}`
  }
  return `/?${new URLSearchParams({
    error: error ?? 'loginFailed',
  })}`
}
